import { render, staticRenderFns } from "./PublicQuery.vue?vue&type=template&id=ac5fcf9c"
import script from "./PublicQuery.vue?vue&type=script&lang=ts"
export * from "./PublicQuery.vue?vue&type=script&lang=ts"
import style0 from "./PublicQuery.vue?vue&type=style&index=0&id=ac5fcf9c&prod&lang=scss&scpoed=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports